import React, { Component } from 'react'
import {Route} from "react-router-dom";

import VentanaDecision from "./VentanaDecision";
import VentanaGuia from "./VentanaGuia";

import "./../styles/ventanaDecisionStyle.css";

export default class RutasVentanasGuias extends Component {

    render() {
        return (
            <div>
                <Route path="/window/decision" component={VentanaDecision}/>
                <Route path="/window/no/1" render={() => {
                    return (<VentanaGuia anterior="/window/decision" siguiente="/window/no/2" contenido={
                        <div>
                            <h2>No estoy en crisis</h2>
                            <p>
                                <b>Este es un momento para que aprendas conocerte, pensar y generar estrategias que  te ayuden
                                a estar preparadx para manejar las crisis, cuando sentís mucha angustia,  desesperación, o
                                te sentís fuera de control.</b>
                                &nbsp;Para eso necesitamos saber que nos pasa.
                                <b>&nbsp;En primer lugar, tenés que saber que no es un problema que solamente te puede estar pasando
                                a vos:</b>
                            </p>
                            <ul>
                                <li>
                                    De acuerdo con la Organización Mundial de la Salud, el suicidio es un grave problema de salud
                                    pública que resulta en 1 millón de muertes prevenibles al año.
                                </li>
                                <li>
                                    En nuestro país es la segunda causa de fallecimiento de jóvenes entre 15 y 24 años.
                                </li>
                                <li>
                                    Quienes más consuman el suicidio son los varones. Mientras que las mujeres lo intentan con más
                                    frecuencia.
                                </li>
                            </ul>
                            <p>
                                El suicidio aparece como una forma de resolver y poner fin a un dolor que se experimenta como interminable,
                                incontrolable e intolerable. No se ve luz al final del túnel, crees que nadie pueda ayudarte. Sentís que
                                estás solx.
                            </p>
                            <p>
                                Pero aunque en ese momento de crisis no lo parezca, esos sentimientos de angustia, de desesperanza, de
                                soledad y desesperación no duran para siempre. En algún momento las cosas empiezan a cambiar. Las crisis
                                no son permanentes.
                            </p>
                            <p>
                                Si no pudiste encontrar una solución, no quiere decir que no la haya, sino que ahora te cuesta verla.
                                Hay personas que te pueden ayudar a pensar alternativas: profesionales, familia o amigxs. Con el tiempo
                                y su ayuda, vas a poder ver las cosas de una forma distinta.
                            </p>
                        </div>
                    }
                    />)
                }}/>
                <Route path="/window/no/2" render={() => {
                    return (<VentanaGuia anterior="/window/no/1" siguiente="/window/no/3" contenido={
                        <div>
                            <h2>¿Cómo saber que estás atravesando una crisis?</h2>
                            <ul>
                                <li>
                                    Sentís mucho dolor, angustia, bronca, desesperación, vergüenza, y/o
                                    impotencia y te es muy difícil manejarlo.
                                </li>
                                <li>
                                    Sentís que la vida no merece la pena y que no hay otra forma de resolver
                                    lo que te pasa.
                                </li>
                                <li>
                                    Tenés ideas suicidas intensas, estás pensando cómo hacerlo, dónde y  cuándo.
                                </li>
                                <li>
                                    Para no pensar o no sentirte mal, consumís drogas y/o alcohol.
                                </li>
                                <li>
                                    Intentaste quitarte la vida.
                                </li>
                            </ul>
                            <h2>¿Qué podés hacer si sentís que estás atravesando un momento de crisis?</h2>
                            <p>
                            En primer lugar, es importante que acudas a una persona de tu confianza o busques un
                            profesional de salud. <b>Pedir ayuda cuando lo necesitamos es un acto de valor. </b>
                            Sin embargo, no siempre es fácil contarle a alguien lo que nos pasa de forma que lo entienda.
                            Te damos algunos TIPS para que puedas prepárate:
                            </p>
                        </div>
                    }
                    />)
                }}/>
                <Route path="/window/no/3" render={() => {
                    return (<VentanaGuia anterior="/window/no/2" siguiente="/register" contenido={
                        <div>
                            <h2>Cómo contarle a alguien lo que me pasa</h2>
                            <ul>
                                <li>
                                    Es importante que primero ordenes lo que querés decir, así lo podés comunicar
                                    en forma clara y ayudás a que el otro te entienda bien. Escribirlo o decirlo en
                                    voz alta puede ser útil.
                                </li>
                                <li>
                                    Empezá diciendo que tenés algo importante para contarle y que necesitás que primero
                                    te escuche hasta que termines de hablar.
                                </li>
                                <li>
                                    Tomate tu tiempo. Si te es más fácil, podés escribirlo y leérselo.
                                </li>
                                <li>
                                    Contale que desde hace un tiempo te estás sintiendo mal, triste, solx o avergonzadx,
                                    contale por qué crees que te pasa esto si lo sabes. Y cómo todo esto te genera pensar
                                    en o hacerte daño.
                                </li>
                                <li>
                                    Explicale que esto que le estás contando es tu manera de pedir ayuda, en ese momento
                                    y en ese lugar.
                                </li>
                                <li>
                                    Sugerile que se descargue la APP Tranqui para que pueda tener la información
                                    necesaria y saber cómo ayudarte.
                                </li>
                            </ul>
                        </div>
                    }/>)
                }}/>
                <Route path="/window/si/1" render={() => {
                    return (<VentanaGuia anterior="/window/decision" siguiente="/register" contenido={
                        <div>
                            <h2 style={{marginBottom: "15px"}}>Consejos Rápidos</h2>
                            <h3>Acordate...</h3>
                            <ul>
                                <li>
                                    Tómate un tiempo. No decidas nada ahora. EL SUICIDIO ES ALGO PERMANENTE ANTE
                                    ESTADOS DE CRISIS QUE SON TEMPORALES.
                                </li>
                                <li>
                                    Aunque ahora no lo parece ni lo sentís así, las cosas cambian. Este malestar
                                    intenso va a disminuir. VA A PASAR.
                                </li>
                                <li>
                                    No consumas alcohol o drogas, solamente va a empeorar las cosas.
                                </li>
                                <li>
                                    Alejate de cualquier medio o lugar en el que te puedas hacer daño.
                                </li>
                                <li>
                                    Hacé las cosas que te generan bienestar y que son saludables para vos.
                                </li>
                                <li>
                                    Hablá, contá lo que te pasa, no lo mantengas en secreto. Recordá que hablar siempre te va a aliviar. Buscá las personas en quienes
                                     confiás o ayuda profesional para superarlas. Llama al SAME <a href="tel:107">107</a> o a la línea de PREVENCIÓN del CAS <a href="tel:0800-345-1435">0800-345-1435</a>.
                                     <i className="icon-phone" style={{fontSize: "14px"}}/>.
                                </li>
                            </ul>
                            <h3>Ahora vas  a poner en marcha tu plan de seguridad si lo tenés armado.</h3>
                            <p>Realizá las actividades hasta que te sientas más tranquilx.</p>
                        </div>
                    }/>)
                }}/>
            </div>
        )
    }
}
